import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARDS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationReplaceSimCard = (onSuccess, onError) => {
    return {
        mutationFn: ({ simUuid, iccid }) => {
            return client.put(replaceParameters(SIM_CARDS.REPLACE.url, { simUuid }), { iccid: iccid });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationReplaceSimCard;